import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, Info } from 'lucide-react';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Sub } from '../../performance-operations/styles';
import { formatDate } from '../../../utils/Utils';
import { insightParams } from '../config';

// Analiz §16 E13 AI alanı — kural tabanlı bulgular (sayılar sunucuda; LLM yok): erişim boşluğu (M40), yönetici geri bildirim
// boşluğu (M41), görüşme takibindeki boşluklar (M42 ve görüşmesiz ekip üyesi sayısı) ve bekleyen talepler. Kişi ya da yönetici
// adı içermez. Serbest metin teması ve duygu analizi ayrı AI özelliğidir — burada üretilmez (panel bunu söyler).
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Item = styled.li`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 10px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgColor};
  border-left: 3px solid ${({ theme, $warning }) => ($warning ? theme.colors.auxiliar.warning : theme.colors.primary.main)};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export default function FeedbackInsightsPanel({ panel }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const s = panel.data;
  const insights = s?.insights || [];
  const range = s ? t('performance.feedbackAnalytics.range', { from: formatDate(s.from, lang), to: formatDate(new Date(new Date(s.to).getTime() - 1), lang) }) : '';
  return (
    <PanelCard
      panelKey="insights" title={t('performance.feedbackAnalytics.panel.insights')} span={5}
      loading={panel.loading} error={panel.error} onRetry={panel.retry}
      empty={!s?.suppressionReason && insights.length === 0} emptyText={t('performance.feedbackAnalytics.insight.none')}
    >
      {s?.suppressionReason ? <Sub data-state="suppressed">{t('performance.feedbackAnalytics.suppressedNote')}</Sub> : (
        <List>
          {insights.map((ins) => {
            const Icon = ins.severity === 'warning' ? AlertTriangle : Info;
            return (
              <Item key={ins.code} $warning={ins.severity === 'warning'} data-insight={ins.code}>
                <Icon size={16} aria-hidden="true" />
                <div>
                  {t(`performance.feedbackAnalytics.insight.${ins.code}`, insightParams(ins, lang))}
                  <Sub>{range}</Sub>
                </div>
              </Item>
            );
          })}
        </List>
      )}
      <Sub style={{ marginTop: 10 }}>{t('performance.feedbackAnalytics.themeNote')}</Sub>
    </PanelCard>
  );
}
